/**
 * @file user-circle.icon.tsx
 * @description Компонент для отображения иконки пользователя в кружке.
 * @author Genotroid
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [classnames]
 */

import cn from 'classnames';
import { IIconProps } from '@src/types';

export const UserCircleIcon = ({ className, color = '#265078', onClick }: IIconProps) => {
    return (
        <div className={cn(className, { 'cursor-pointer': onClick })} onClick={onClick}>
            <svg
                width="3.177vmin"
                height="3.177vmin"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.99992 0.333496C3.31792 0.333496 0.333252 3.31816 0.333252 7.00016C0.333252 10.6822 3.31792 13.6668 6.99992 13.6668C10.6819 13.6668 13.6666 10.6822 13.6666 7.00016C13.6666 3.31816 10.6819 0.333496 6.99992 0.333496ZM4.66658 5.3335C4.66658 5.02708 4.72694 4.72366 4.8442 4.44057C4.96146 4.15747 5.13333 3.90025 5.35 3.68358C5.56667 3.46691 5.8239 3.29504 6.10699 3.17778C6.39008 3.06052 6.6935 3.00016 6.99992 3.00016C7.30634 3.00016 7.60975 3.06052 7.89285 3.17778C8.17594 3.29504 8.43316 3.46691 8.64983 3.68358C8.8665 3.90025 9.03838 4.15747 9.15564 4.44057C9.2729 4.72366 9.33325 5.02708 9.33325 5.3335C9.33325 5.95233 9.08742 6.54583 8.64983 6.98341C8.21225 7.421 7.61876 7.66683 6.99992 7.66683C6.38108 7.66683 5.78759 7.421 5.35 6.98341C4.91242 6.54583 4.66658 5.95233 4.66658 5.3335ZM11.1719 10.3228C10.6727 10.9504 10.0383 11.4572 9.31587 11.8053C8.59349 12.1534 7.80182 12.334 6.99992 12.3335C6.19802 12.334 5.40635 12.1534 4.68397 11.8053C3.96158 11.4572 3.32712 10.9504 2.82792 10.3228C3.90859 9.54749 5.38325 9.00016 6.99992 9.00016C8.61658 9.00016 10.0913 9.54749 11.1719 10.3228Z"
                    fill={color}
                />
            </svg>
        </div>
    );
};
